export default function NotFound({
  type
}) {
  return <div className="border border-red-300 text-red-300" data-sentry-component="NotFound" data-sentry-source-file="not-found.tsx"> Missing Tastic : {type}</div>;
}